import { Button, notification, Row, Table } from "antd";
import moment from "moment";
import React, { ReactElement, useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  EditableList,
} from "../../../compnents/list/EditableList";

import { PrinterOutlined } from "@ant-design/icons";
import { NavBar } from "../../../compnents/nav/NavBar";
import { DateTimeFormatSimple } from "../../../models/datetime";
import { InventoryRecordsParams } from "../../../services/inventoryRecords";
import { InventoryRecordsColumns } from "./columns";
import { ThemeContext } from "../../../theme/ThemeContext";
import { getInventoryRecordsList, selectCurrent, selectInventoryRecord, selectTotal, setCurrent, getInventoryRecordsListExoprt, selectPageLoading, setPageLoading } from "./inventoryRecordSlice";
import { InventoryRecordsQuery } from "./Query";
import styles from "./invent.module.css";
import ReactToPrint from "react-to-print";
import { PrintOutlined } from "../../../compnents/icons/Icons";
import { unwrapResult } from "@reduxjs/toolkit";
import { RootDispatch } from "../../../app/store";
import { SJQXChecks } from "../../../models/dataPersion";
import { getCheckPermissionAsync } from "../../FunctionSetting/dataPermission/dataPermissionSlice";
import { PrintFrame, PrintFrameRef } from "../../print/PrintFrame";
import { selectTenantName } from "../../../app/applicationSlice";
import { selectSettings } from "../../user/setting/settingSlice";

const getMaterialsCategoryQueryParams = (queries: InventoryRecordsParams) => {
  const materialsCategoryList = queries?.materialsCategoryList

  if (queries?.materialsCategory || queries?.category) {
    return {
      materialsCategory: queries?.materialsCategory,
      category: queries?.category,
    }
  }

  if (Array.isArray(materialsCategoryList) && Array.isArray(materialsCategoryList[0])) {
    const materialsCategory = Array.from(
      new Set(
        materialsCategoryList
          .map((item: any) => item?.[0])
          .filter((item: any) => item !== undefined && item !== null && item !== '')
      )
    ).join(',')
    const category = Array.from(
      new Set(
        materialsCategoryList
          .map((item: any) => item?.[1])
          .filter((item: any) => item !== undefined && item !== null && item !== '')
      )
    ).join(',')

    return {
      materialsCategory: materialsCategory || undefined,
      category: category || undefined,
    }
  }

  return {
    materialsCategory: Array.isArray(materialsCategoryList) ? materialsCategoryList?.[0] : undefined,
    category: Array.isArray(materialsCategoryList) ? materialsCategoryList?.[1] : undefined,
  }
}

export const InventoryRecords = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>();

  const tenantName = useSelector(selectTenantName)

  const [queries, setQueries] = useState<InventoryRecordsParams>({
    upAccountTimeStart: moment().startOf("day").format(DateTimeFormatSimple),
    upAccountTimeEnd: moment().endOf("day").format(DateTimeFormatSimple),
  });

  const settings = useSelector(selectSettings)

  const Current = useSelector(selectCurrent);

  const total = useSelector(selectTotal);

  const data = useSelector(selectInventoryRecord);

  const [size, setSize] = useState(10);

  const theme = useContext(ThemeContext);

  const ref = useRef(null);

  const printRef = useRef<PrintFrameRef>(null)
  
  const [cell, setCell] = useState<any>({})   //合计栏

  const pageLoadingRX = useSelector(selectPageLoading);

  const [exportLoading, setExportLoading] = useState(false)

  const [KFGZZCKLRSJData, setKFGZZCKLRSJData] = useState<any>(true)   //KFGZZCKLRSJ权限

  useEffect(() => {
    if (queries?.timeHead) {
      dispatch(setPageLoading(true))
      dispatch(getInventoryRecordsList({
        ...queries,
        materialsCategoryList: undefined,
        ...getMaterialsCategoryQueryParams(queries),
        current: Current,
        size,
        timeTail: undefined,
        timeHead: undefined,
        upAccountTimeStart:
          moment(queries.timeHead).format(
            DateTimeFormatSimple,
          ),
        upAccountTimeEnd: moment(queries.timeTail).format(
          DateTimeFormatSimple,
        )
      }
      ))
      setTimeout(() => {
        dispatch(setPageLoading(false))
      }, 3000)
    }
  }, [queries, size, Current,]);

  // 库房工作站查看利润数据权限
  useEffect(() => {
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KFGZZCKLRSJ }))
      .then(unwrapResult)
      .then((res: any) => {
        setKFGZZCKLRSJData(res)
      })
  }, [])

  useEffect(() => {
    if (data.length == 0) return
    const tempArr = data.filter((item: any) => {
      return item.totalAccountBooksNumber != -1
    })
    setCell(tempArr[0])
  }, [data])

  const outCluedExport = () => {
    setExportLoading(true)
    dispatch(getInventoryRecordsListExoprt({
      ...queries,
      materialsCategoryList: undefined,
      ...getMaterialsCategoryQueryParams(queries),
      current: Current,
      size,
      timeTail: undefined,
      timeHead: undefined,
      upAccountTimeStart:
        moment(queries.timeHead).format(
          DateTimeFormatSimple,
        ),
      upAccountTimeEnd: moment(queries.timeTail).format(
        DateTimeFormatSimple,
      )
    }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res;
        const blob = new Blob([content]);
        const fileName = '盘点记录查询.xlsx';
        const selfURL = window[window.webkitURL ? "webkitURL" : "URL"];
        const elink = document.createElement("a");
        if ("download" in elink) {
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = selfURL["createObjectURL"](blob);
          document.body.appendChild(elink);
          // 触发链接
          elink.click();
          selfURL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          return (navigator as any).msSaveBlob(blob, fileName);
        }
      })
      .then(() => {
        notification.success({
          message: "导出成功",
          duration: 3,
        });
      })
      .catch((res: any) => {
        return
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <NavBar
        style={{ margin: '10px 20px 0px 20px' }}
        where={['库存', '盘点记录查询']}
        backtrace={{
          name: '库房工作站',
          path: '/storage/station',
          state: { station: '3' },
        }}
        buttons={
          // <ReactToPrint
          //   trigger={() => (
              <Button
                style={{
                  border: 'none',
                  background: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                }}
                size='small'
                onClick={() => {
                  dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KFGZZDCDYQX }))
                    .then(unwrapResult)
                    .then((res: any) => {
                      printRef.current?.print()
                    })
                }}
              >
                <PrintOutlined
                  style={{
                    fill: '#666',
                    width: '18px',
                    height: '18px',
                    marginRight: '8px',
                  }}
                />
                打印
              </Button>
            // )}
            // content={() => ref.current}
          // />
        }
      />
      <div className={styles.content}>
        <InventoryRecordsQuery
          exportloading={exportLoading}
          loading={pageLoadingRX}
          onValueChange={(v) => {
            setQueries({ ...queries, ...v })
            dispatch(setCurrent(1))
          }}
          outClued={() => {
            dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KFGZZDCDYQX }))
              .then(unwrapResult)
              .then((res: any) => {
                outCluedExport()
              })
          }}
        />
        <div ref={ref} style={{ height: 'calc(100% - 92px)' }}>
          <EditableList
            style={{ height: '100%', overflowY: 'auto' }}
            loading={pageLoadingRX}
            summary={() => (
              <Table.Summary fixed>
                <Table.Summary.Row className={styles.total}>
                  <Table.Summary.Cell index={0}></Table.Summary.Cell>
                  <Table.Summary.Cell className={styles.footingTitle} index={1}>
                    合计
                  </Table.Summary.Cell>
                  <Table.Summary.Cell
                    align='center'
                    index={2}
                  ></Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={3}>
                    {cell.totalAccountBooksNumber || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={4}>
                    {cell.totalRealCount || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={5}>
                    {cell.totalCheckCount || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={6}>
                    {cell?.totalSplitAccountBooksNumber || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={7}>
                    {cell.totalSplitRealCount || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={8}>
                    {cell.totalSplitCheckCount || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={9}>
                    {!KFGZZCKLRSJData ? '***' : cell.totalUnitPrice || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='right' index={10}>
                    {!KFGZZCKLRSJData ? '***' : cell.totalChangePrice || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={11}></Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            )}
            bordered
            className={styles.invent}
            rowKey={(_, i) =>
              queries
                ? (queries.size || 0) * (queries.current || 0) + (i || 0)
                : 0
            }
            onChangePage={(current, pageSize) => {
              setSize(pageSize as number)
              dispatch(setCurrent(current))
            }}
            page={{
              items: data,
              current: Current,
              size: size,
              total: total,
            }}
            columns={InventoryRecordsColumns(size * (Current - 1), KFGZZCKLRSJData, settings)}
          />
        </div>
      </div>
      <PrintFrame
        ref={printRef}
        title={tenantName?.split('-')?.[0]}
        subTitle='盘点记录查询'
      >
        <EditableList
          style={{ height: '100%', overflowY: 'auto' }}
            loading={pageLoadingRX}
            summary={() => (
              <Table.Summary fixed>
                <Table.Summary.Row className={styles.total}>
                  <Table.Summary.Cell index={0}></Table.Summary.Cell>
                  <Table.Summary.Cell className={styles.footingTitle} index={1}>
                    合计
                  </Table.Summary.Cell>
                  <Table.Summary.Cell
                    align='center'
                    index={2}
                  ></Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={3}>
                    {cell.totalAccountBooksNumber || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={4}>
                    {cell.totalRealCount || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={5}>
                    {cell.totalCheckCount || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={6}>
                    {cell?.totalSplitAccountBooksNumber || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={7}>
                    {cell.totalSplitRealCount || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={8}>
                    {cell.totalSplitCheckCount || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={9}>
                    {!KFGZZCKLRSJData ? '***' : cell.totalUnitPrice || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='right' index={10}>
                    {!KFGZZCKLRSJData ? '***' : cell.totalChangePrice || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={11}></Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            )}
            bordered
            className={styles.invent}
            rowKey={(_, i) =>
              queries
                ? (queries.size || 0) * (queries.current || 0) + (i || 0)
                : 0
            }
            onChangePage={(current, pageSize) => {
              setSize(pageSize as number)
              dispatch(setCurrent(current))
            }}
            page={{
              items: data,
              current: Current,
              size: size,
              total: total,
            }}
          columns={InventoryRecordsColumns(size * (Current - 1), KFGZZCKLRSJData, settings)}
        />
      </PrintFrame>
    </div>
  )
};
